import { useEffect, useState } from "react";
import Sidebar from "../Components/Sidebar";
import Topbar from "../Components/Topbar";

export default function DashboardLayout({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved === "true";
  });
  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/admin/me", {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setPermissions(data.permissions || []);
          setRole(data.admin.role);
        } else {
          window.location.href = "/adminlogin";
        }
      })
      .catch(() => {
        window.location.href = "/adminlogin";
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="min-h-screen bg-[#07070b]" />;
  }

  const toggleCollapsed = (value) => {
    setCollapsed(value);
    localStorage.setItem("sidebarCollapsed", value);
  };

  return (
    <div className="bg-[#0b0b0f] min-h-screen text-white">
      <Sidebar
        permissions={permissions}
        role={role}
        collapsed={collapsed}
        setCollapsed={toggleCollapsed}
      />
      <Topbar collapsed={collapsed} />

      <main
        className={`
          ${collapsed ? "ml-20" : "ml-72"}
          pt-24
          p-10
          min-h-screen
          relative
          overflow-hidden
          transition-all duration-300
          bg-gradient-to-br from-[#0e0e14] via-[#0b0b0f] to-[#0e0e14]
        `}
      >
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.02]
          bg-[url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22100%22 height=%22100%22%3E%3Ccircle cx=%221%22 cy=%221%22 r=%221%22 fill=%22white%22/%3E%3C/svg%3E')]
        "
        />
        {children}
      </main>
    </div>
  );
}
